import React, { createContext, useState, useContext } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { updateKitchenOperationAPI, addDedicatedDriverAPI } from './../api-services/Signup.service'



import { API_NETWORK_ERROR, localStorageKeys } from "../../utils/constants";

export const KitchenOperationUpdateContext = createContext();
const FutureCustomerDataProvider = ({ children }) => {

    const [kitchenUpdateAPIResponse, setKitchenUpdateAPIResponse] = useState({
        loading: false,
        success: null,
        message: null,
        data: null,
    });

    const { REFRESH_TOKEN, TOKEN, } = localStorageKeys;
    const hasTokens = localStorage.getItem(TOKEN);

    let KitchenName = null
    if (hasTokens) {
        const decodedToken = jwtDecode(hasTokens);
        const { email, kitchenName } = decodedToken || null;
        KitchenName = kitchenName

    }

    const onKitchenOperationUpdateAPI = async (operationPayload) => {

        try {

            const gettingToken = localStorage.getItem(TOKEN);
            if (gettingToken) {
                axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`
            } else {
                setKitchenUpdateAPIResponse({
                    success: false,
                    loading: false,
                    data: null,
                    errorMessage: 'Token & Refresh Token missing',
                })
                return;
            }


             setKitchenUpdateAPIResponse({
                loading: true,
                success: null,
                message: null,
                data: null,
            });


            /* Prefer JWT kitchen_name; allow callers (e.g. store settings) to pass kitchen_name when token omits it */
            const payload = {
                ...operationPayload,
                kitchen_name: KitchenName || operationPayload.kitchen_name,
            }


            const data = await updateKitchenOperationAPI(payload);

            if (data.hasError) {
                setKitchenUpdateAPIResponse({
                    loading: false,
                    data: null,
                    success: !data.hasError,
                    message: data.message
                });
                return data
            }

            if (data.data?.success) {
                 setKitchenUpdateAPIResponse({
                    loading: false,
                    data: data,
                    success: data.data?.success,
                    message: data.data?.message,

                });

                return data?.data

            } else {
                 setKitchenUpdateAPIResponse({
                    loading: false,
                    data: data,
                    success: data.data?.success,
                    message: data.data?.message,
                });
            }
            return data?.data;
        } catch (error) {
            console.log('---Catch blackonKitchenOperationUpdateAPI', error)
            setKitchenUpdateAPIResponse({ loading: false, data: null, success: false, message: error, })

        }
    };

    const onAddDedicatedDriverAPI = async (payload) => {
        try {
            const gettingToken = localStorage.getItem(TOKEN);
            if (gettingToken) {
                axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`
            } else {
                setKitchenUpdateAPIResponse({
                    success: false,
                    loading: false,
                    data: null,
                    errorMessage: 'Token & Refresh Token missing',
                })
                return;
            }

            setKitchenUpdateAPIResponse({
                loading: true,
                success: null,
                message: null,
                data: null,
            });

            const body = {
                ...payload,
                kitchen_name: KitchenName || payload.kitchen_name,
            };

            const data = await addDedicatedDriverAPI(body);

            if (data.hasError) {
                setKitchenUpdateAPIResponse({
                    loading: false,
                    data: null,
                    success: !data.hasError,
                    message: data.message
                });
                return data;
            }

            const resBody = data.data;
            const ok = resBody?.success === true;
            const msg = resBody?.customMessage || resBody?.message || resBody?.CustomMessage;

            if (ok) {
                setKitchenUpdateAPIResponse({
                    loading: false,
                    data: data,
                    success: true,
                    message: msg,
                });
                return resBody;
            }

            setKitchenUpdateAPIResponse({
                loading: false,
                data: data,
                success: false,
                message: msg,
            });
            return resBody;
        } catch (error) {
            console.log('---Catch onAddDedicatedDriverAPI', error)
            setKitchenUpdateAPIResponse({ loading: false, data: null, success: false, message: error, })
        }
    };



    return (

        <KitchenOperationUpdateContext.Provider
            value={{
                kitchenUpdateAPIResponse,
                setKitchenUpdateAPIResponse,
                onKitchenOperationUpdateAPI,
                onAddDedicatedDriverAPI,
            }}
        >
            {children}
        </KitchenOperationUpdateContext.Provider>
    )


}

export default FutureCustomerDataProvider;
